import { Home, Zap, Sparkles, Award, Timer, Car } from "lucide-react";

const FEATURES = [
  { icon: Home, title: "Déplacement à domicile", desc: "Nous venons directement chez vous, à votre convenance, dans toute la zone de Versailles." },
  { icon: Zap, title: "100% Autonome", desc: "Eau et électricité fournies par nos équipements professionnels embarqués." },
  { icon: Sparkles, title: "Produits professionnels", desc: "Shampoings, cires et traitements haut de gamme pour un résultat de concession." },
  { icon: Award, title: "Résultat premium", desc: "Souci du détail, finition impeccable, satisfaction garantie sur chaque prestation." },
  { icon: Timer, title: "Service rapide", desc: "Intervention efficace sans sacrifier la qualité. Réservation en ligne simplifiée." },
  { icon: Car, title: "Intérieur, extérieur & rénovation", desc: "Un service complet adapté à tous types de véhicules, même les plus exigeants." },
];

export default function WhyUs() {
  return (
    <section id="pourquoi-nous" className="relative py-28 lg:py-36 overflow-hidden" data-testid="why-us-section">
      <div className="absolute top-1/4 left-0 w-[400px] h-[400px] bg-[#E50914]/8 rounded-full blur-[140px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        {/* Section header */}
        <div className="max-w-3xl mb-20">
          <div className="text-xs uppercase tracking-[0.3em] text-[#E50914] font-bold mb-4">
            / 01 — Nos engagements
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-6">
            Pourquoi choisir<br />
            <span className="text-gradient-red">Nova Clean Service ?</span>
          </h2>
          <p className="text-white/60 text-lg leading-relaxed">
            Une approche artisanale, des outils professionnels, un service pensé pour vous faire gagner du temps sans jamais compromettre la qualité.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <FeatureCard key={f.title} {...f} idx={i} />
          ))}
        </div>

        {/* Tag line */}
        <div className="mt-24 relative text-center">
          <div className="inline-block relative">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-3 font-mono">// signature</div>
            <div className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">
              Votre voiture, <span className="italic text-[#E50914] font-serif" style={{ fontFamily: 'Outfit' }}>notre passion.</span>
            </div>
            <div className="mt-4 flex items-center justify-center gap-3">
              <div className="h-px w-16 bg-white/20"></div>
              <span className="text-xs uppercase tracking-[0.25em] text-white/40">Nova Clean Service</span>
              <div className="h-px w-16 bg-white/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ icon: Icon, title, desc, idx }) {
  return (
    <div
      data-testid={`feature-card-${idx}`}
      className="group relative p-8 bg-gradient-to-b from-[#161616] to-[#0B0B0B] border border-white/10 rounded-xl hover:border-[#E50914]/40 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#E50914]/0 group-hover:bg-[#E50914]/10 rounded-full blur-3xl transition-colors duration-500"></div>

      <div className="relative">
        <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#E50914]/20 to-transparent border border-[#E50914]/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <Icon className="w-6 h-6 text-[#E50914]" strokeWidth={2} />
        </div>
        <h3 className="text-xl font-bold mb-3 text-white">{title}</h3>
        <p className="text-sm text-white/60 leading-relaxed">{desc}</p>

        <div className="mt-6 font-mono text-[10px] text-white/30">
          / 0{idx + 1}
        </div>
      </div>
    </div>
  );
}
